// ABOUTME: Connects gameStore activity to celebration system
// ABOUTME: Watches for level-ups and achievements to trigger celebrations

import { useEffect, useRef } from 'react'
import { useGameStore } from '@/lib/store/gameStore'
import { useCelebrationContext } from '@/components/providers/CelebrationProvider'

export function useGameCelebrations() {
  const { recentActivity, level } = useGameStore()
  const { triggerLevelUp, triggerAchievement, addXPGain } = useCelebrationContext()
  const previousLevel = useRef(level)
  const processedActivityIds = useRef(new Set<string>())

  useEffect(() => {
    // Check for level up
    if (level > previousLevel.current) {
      triggerLevelUp(level)
      previousLevel.current = level
    }
  }, [level, triggerLevelUp])

  useEffect(() => {
    // Process new activities
    recentActivity.forEach((activity) => {
      if (processedActivityIds.current.has(activity.id)) return
      processedActivityIds.current.add(activity.id)

      switch (activity.type) {
        case 'achievement_unlocked': {
          triggerAchievement(activity.message)
          break
        }
        case 'xp_gained': {
          if (activity.experienceGained) {
            addXPGain(activity.experienceGained)
          }
          break
        }
      }
    })
  }, [recentActivity, triggerAchievement, addXPGain])
}
